import React from 'react'
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts'

import ChartTooltip from './ChartTooltip'

/**
 * Daily activity per entity, with a crosshair tooltip.
 *
 * Entity colours match the leaderboard, so a hue means the same thing on both.
 * Only entities that actually appear in the range get a line -- an always-seven
 * legend of mostly flat zeroes reads as noise.
 */
const TrendLine = ({ data, series, height = 320, showLegend = true }) => (
    <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#e1e0d9" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#898781' }} stroke="#c3c2b7" minTickGap={16} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#898781' }} stroke="#c3c2b7" width={44} />
            <Tooltip content={<ChartTooltip total />} cursor={{ stroke: '#c3c2b7', strokeWidth: 1 }} />
            {showLegend && <Legend wrapperStyle={{ fontSize: 12 }} />}
            {series.map((item) => (
                <Line
                    key={item.key}
                    type="monotone"
                    dataKey={item.key}
                    name={item.label}
                    stroke={item.color}
                    strokeWidth={2}
                    dot={false}
                    activeDot={{ r: 4, strokeWidth: 2, stroke: '#ffffff' }}
                />
            ))}
        </LineChart>
    </ResponsiveContainer>
)

export default TrendLine
